import { Avatar, styled } from "@mui/material";
import { useDebugSettings } from "../../../tools";
import { useSettings } from "../tools";
import DebugInfoPanel from "../DebugInfoPanel";
import { getNameLetters } from "../room/tools";
import { InitializedMediaDevices, VideoTrack } from "@dvrt/web-phone-client";
import { useSelectedVideoStream } from "@dvrt/web-phone-client/hooks";

const width = 500;
const height = 250;

const Preview = styled("div")(({ theme }) => ({
    width: "fit-content",
    position: "relative",
    "&:hover .settingsButton": {
        opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
        height: "100%",
        width: "100%",
    },
}));

const VideoElement = styled(VideoTrack)(({ theme }) => ({
    maxWidth: width,
    maxHeight: height,
    transform: "scaleX(-1)",
    [theme.breakpoints.down("sm")]: {
        maxWidth: "unset",
        maxHeight: "unset",
        width: "100%",
    },
}));

const PlaceholderDiv = styled("div")({
    padding: "5em",
});

const Placeholder = () => {
    const { displayName } = useSettings();
    return (
        <PlaceholderDiv>
            <Avatar style={{ fontSize: "1.1rem" }}>{getNameLetters(displayName ?? "")}</Avatar>
        </PlaceholderDiv>
    );
};

const Live = () => {
    const debugSettings = useDebugSettings();
    const track = useSelectedVideoStream()?.getVideoTracks()[0];

    if (!track) return <Placeholder />;

    return (
        <>
            <Preview>
                <VideoElement track={track} />
                {debugSettings.enabled && debugSettings.showVideoInfo && <DebugInfoPanel track={track} />}
            </Preview>
        </>
    );
};

const VideoPreview = () => {
    const settings = useSettings();

    if (!settings.video) return <Placeholder />;

    return (
        <InitializedMediaDevices placeholder={<Placeholder />}>
            <Live />
        </InitializedMediaDevices>
    );
};

export default VideoPreview;
